import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Layout from "./components/Layout/Layout";
import Module from "./components/Module/Module";
import Contact from "./components/Contact/Contact";
import Resources from "./components/Resources/Resources";
import ErrorComponent from "./components/ErrorComponent/ErrorComponent";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { ModuleData } from "./components/Module/ModuleData";

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <ErrorComponent />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "module1",
        element: (
          <Module
            embedId="NBPfa5j5-BA?si=OM1BvtwbVcdsEmKA "
            moduleData={ModuleData.Module1}
            moduleTitle="Module 1"
          />
        ),
      },
      {
        path: "module2",
        element: (
          <Module
            embedId="dchGrrFu0QU"
            moduleData={ModuleData.Module2}
            moduleTitle="Module 2"
          />
        ),
      },
      {
        path: "module3",
        element: (
          <Module
            embedId="5fcyRk-W6Hs"
            moduleData={ModuleData.Module3}
            moduleTitle="Module 3"
          />
        ),
      },
      {
        path: "module4",
        element: (
          <Module
            embedId="-MSoObXdpac"
            moduleData={ModuleData.Module4}
            moduleTitle="Module 4"
          />
        ),
      },
      {
        path: "outro",
        element: (
          <Module embedId="zhlhLk2JVsc " moduleData={{}} moduleTitle="Outro" />
        ),
      },
      {
        path: "resources",
        element: <Resources />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
